import React from 'react';
import usePrdAgent from '../../../../utils/usePrdAgent';
import ConversationList from './ConversationList';
import PrdChat from './PrdChat';
import ArtifactSidebar from './ArtifactSidebar';

export default function PrdAgentLayout() {
    const {
        conversations,
        activeConversation,
        isStreaming,
        isLoading,
        isLoadingConversation,
        isLoadingList,
        error,
        activeArtifact,
        lockState,
        send,
        startNew,
        resume,
        remove,
        openArtifact,
        closeArtifact,
        lockOnSubmit,
    } = usePrdAgent();

    return (
        <div className={`prd-agent-layout ${activeArtifact ? 'prd-agent-layout--with-sidebar' : ''}`}>
            <ConversationList
                conversations={conversations}
                activeSessionId={activeConversation ? activeConversation.sessionId : null}
                isLoading={isLoading}
                isLoadingList={isLoadingList}
                onSelect={resume}
                onDelete={remove}
                onNew={startNew}
            />

            <main className="prd-main">
                {isLoadingConversation ? (
                    <div className="empty-state empty-state--full">
                        <div className="conversation-loader">
                            <span className="dot dot--1"></span>
                            <span className="dot dot--2"></span>
                            <span className="dot dot--3"></span>
                        </div>
                        <p>Cargando conversación...</p>
                    </div>
                ) : activeConversation ? (
                    <PrdChat
                        messages={activeConversation.messages}
                        isStreaming={isStreaming}
                        isLoading={isLoading}
                        error={error}
                        onSend={send}
                        onOpenArtifact={openArtifact}
                        lockState={lockState}
                    />
                ) : (
                    <div className="empty-state empty-state--full">
                        <p>Selecciona una conversación o crea una nueva para comenzar.</p>
                        <button className="btn-start" onClick={startNew}>
                            Crear conversación
                        </button>
                    </div>
                )}
            </main>

            {activeArtifact && (
                <ArtifactSidebar
                    artifact={activeArtifact}
                    onClose={closeArtifact}
                    isBlocked={lockState.locked}
                    onSubmitted={lockOnSubmit}
                />
            )}
        </div>
    );
}
